import { render } from "./Datos.vue?vue&type=template&id=ed5a0ab6"
import script from "./Datos.vue?vue&type=script&lang=js"
export * from "./Datos.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vento-proveedores\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__